
export function hideCartTesInStock() {
    // Return true - to hide all ETA and Will Ship messaging
    // Return false - to display all ETA and Will Ship messaging
    return false;
}

export function showDropShipInStock() {
    var hasDropShipMsg = $('input[name="hasOldDropShipMsg"]'),
        $miniCartShip = $('.dropShipMsg .miniCartShip');

    if (hasDropShipMsg.length && hasDropShipMsg.val()) {
        $miniCartShip.html('Ships within 1 business day');
    } else {
        $miniCartShip.html('Yes');
    }
}